import { useLocation } from 'react-router-dom';

export default function ComingSoon() {
  const loc = useLocation() as { state?: { feature?: string } };
  const feature = loc.state?.feature || 'This area';
  return (
    <div className="px-6 py-12 max-w-2xl mx-auto text-center">
      <h1 className="h-display text-4xl mb-3">{feature}</h1>
      <p className="text-dg-mist">
        Coming soon — wired up in a future sprint. The sidebar IA is locked from
        day 1, but the underlying surfaces ship sprint-by-sprint.
      </p>
    </div>
  );
}
